import { useOrganisationId } from 'hooks/context';

import {
  DateRangeFilter,
  type DateRangeDefaultFilters
} from 'components/ui/organisms/DateRangeFilter';

type Props = {
  defaultFilters: DateRangeDefaultFilters;
  onChange: (...args: any[]) => void;
};

export const DateRangeWrapper = ({ defaultFilters, onChange }: Props) => {
  const _ = useOrganisationId();

  return (
    <div className="group relative">
      <DateRangeFilter defaultFilters={defaultFilters} onChange={onChange} />
    </div>
  );
};
